/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Drawer } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";
import vruddhiIcon from "../../../Assets/images/svg/vruddhi_v_icon.svg";
import darpanLogo from "../../../Assets/images/svg/darpan_logo.svg";
import arrowIcon from "../../../Assets/images/svg/dar_arrow4.svg";
import "./desktop.scss";

const DesktopSideBar = ({ menuItems, isOpen, onToggle }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleMenuItemClick = async (item) => {
    if (item.isLogout) {
      await logout();
      navigate('/');
    } else if (item.link === '/') {
      sessionStorage.removeItem('propertiesCache');
      navigate('/', { state: { homeRefreshAt: Date.now() } });
    } else if (item.link) {
      navigate(item.link);
    }
  };

  return (
    <Drawer
      variant="permanent"
      open={isOpen}
      className={`drawer-main-sec ${!isOpen ? "collapsed" : ""}`}
    >
      <div className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
        
        {/* Toggle Button - positioned at top right */}
        <button className="collapse-button" onClick={onToggle}>
          <img
            className={`arrow-icon ${isOpen ? 'rotated' : ''}`}
            src={arrowIcon}
            alt="Toggle"
          />
        </button>

        {/* Logo Section */}
        <div className="logo-section">
          {isOpen ? (
            <img src={darpanLogo} alt="Vruddhi Logo" className="logo-full" />
          ) : (
            <img src={vruddhiIcon} alt="Vruddhi" className="logo-icon" />
          )}
        </div>

        {/* Menu Items */}
        <div className="sidebar-menu">
          {menuItems.map((item) => (
            <div 
              key={item.id} 
              className={`menu-item ${item.isLogout ? 'logout-item' : ''}`}
              onClick={() => handleMenuItemClick(item)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={item.selectedIcon}
                alt={item.text}
                className="menu-icon"
              />

              <span className="menu-text">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </Drawer>
  );
};

DesktopSideBar.propTypes = {
  menuItems: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default DesktopSideBar;